import {Dropdown, IDropdownOption, IDropdownStyles} from '@fluentui/react';
import React from "react";


const dropdownStyles: Partial<IDropdownStyles> = {
    dropdown: { width: 70 }
};
const options: IDropdownOption[] = [
    { key: 'yes', text: 'Yes' },
    { key: 'no', text: 'No' }
];

class ExternalCollaboration extends React.Component {

    constructor(props)
    {
        super(props);
        this.state = {editable: true}
    }

    onChange(e,v)
    {
        this.props.onUpdate('externalCollaboration', v.key==='yes');
    }

    render() {
        return (
            <div style={{width:'100%',position:'relative'}}>
                <span> External Collaboration: </span>
                <div className="dropdown">
                <Dropdown
                    onChange={this.onChange.bind(this)}
                    disabled={this.props.disabled || this.props.isreadonly}
                    defaultSelectedKey={this.props.externalCollaboration? 'yes' : 'no'}
                    options={options}
                    styles={dropdownStyles}
                />
                </div>
            </div>
        );
    }
}
export default ExternalCollaboration;





// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/ExternalCollaboration.js